import { graphql } from 'react-relay';

export const detailFilterDropdownCategoryFragment = graphql`
    fragment DetailFilterDropdownCategory_category on DetailFilterDropdownCategory {
        col
        categoryname
        info {
            ...CategoryInfo_info
        }
        selectbox {
            ...Selectbox_selectBox
        }
    }
`;
